import { ApiResponse, Pagination } from "interfaces/models/api";
import {
  CountTaskTypesResponse,
  TaskType,
  TASK_TYPE_INITIAL,
} from "interfaces/models/taskType";
import networkMonitor from "libs/network-monitor/NetworkMonitor";
import { axiosECS } from "services/baseAxios";
import { validateBodyReq } from "utils/common";
import { PATH_API } from "constants/api";

const path = PATH_API.TASK_TYPE;
const DEFAULT_LIMIT = 500;

interface GetTaskTypesReq extends Pagination {
  paging?: "cursor" | "offset" | undefined;
  title?: string;
  deleted?: boolean;
  exact?: boolean;
  shouldCache?: boolean;
}

export const getTaskTypesList = async (
  params: GetTaskTypesReq
): Promise<ApiResponse<TaskType[]>> => {
  return { data: [] };
};

export const countTaskTypeList = async (
  params: GetTaskTypesReq
): Promise<ApiResponse<CountTaskTypesResponse>> => {
  return { data: { totalItem: 0, totalPage: 0 } };
};

export const createTaskType = async (
  taskType: Partial<TaskType>
): Promise<ApiResponse<TaskType>> => {
  return axiosECS.post(path, validateBodyReq(taskType));
};

export const updateTaskType = async (
  taskType: TaskType
): Promise<ApiResponse<TaskType>> => {
  const updatedAt = taskType.updatedAt || new Date();
  const nullFields = [
    "goodImageUrl",
    "badImageUrl",
    "goodDescription",
    "badDescription",
  ];
  const bodyClone = structuredClone(taskType) as { [key: string]: any };
  for (const key in bodyClone) {
    if (bodyClone[key] === "" && nullFields.includes(key)) {
      bodyClone[key] = bodyClone[key] || null;
    }
  }

  return axiosECS.patch(path, { ...bodyClone, updatedAt });
};

export const deleteTaskTypeList = async (
  ids: string[]
): Promise<ApiResponse<string[]>> => {
  return await axiosECS.delete(path, { data: { ids } });
};

export const getTaskTypeByTitle = async (title: string) => {
  return await getTaskTypesList({ title, exact: true });
};

export const handleGetTaskTypes = async (params: GetTaskTypesReq) => {
  return [];
};

export const upsertTaskType = async (taskType: TaskType) => {
  const { id } = taskType;

  if (id && id !== TASK_TYPE_INITIAL.id) {
    return await updateTaskType(taskType);
  }

  return await createTaskType(taskType);
};

export const createListTaskType = async (taskTypes: TaskType[]) => {
  const {
    data,
  }: {
    data: {
      success: number;
      errorTitles: string[];
    };
  } = await axiosECS.post(
    `${path}/list`,
    validateBodyReq({ items: taskTypes })
  );

  return data;
};
